export default {
  toasts: {
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt.',
    successfully_saved: 'Succesvol opgeslagen.',
  },
  form: {
    has_multiple_locations: {
      label: 'Verschillende locaties voor de week instellen',
    },
  },
  labels: {
    day_location: '{{day}} locatie {{index}}',
    selected_days: 'Geselecteerde dagen',
    orders_paused: 'Bestellingen gepauzeerd',
    open_time: 'Openingstijd',
    close_time: 'Sluitingstijd',
  },
  buttons: {
    save: 'Opslaan',
  },
};
